exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__3rXsY{display:flex;padding:1.5rem 1rem;align-items:center;flex-wrap:wrap;min-height:5.25rem}.style_titleContainer__3-W7u{flex:1 0 auto;font-size:1.25rem}.style_header__2STZ0{margin:0;padding:0}.style_title__YSj5Z{display:flex;flex-direction:row;align-items:center;line-height:1.75rem}.style_logo__13jHw{margin-right:.5rem}.style_refreshContainer__1D4wv{position:relative;height:1.75rem;opacity:.8}", ""]);

// exports
exports.locals = {
	"container": "style_container__3rXsY",
	"titleContainer": "style_titleContainer__3-W7u",
	"header": "style_header__2STZ0",
	"title": "style_title__YSj5Z",
	"logo": "style_logo__13jHw",
	"refreshContainer": "style_refreshContainer__1D4wv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SectionTitle/style.less
// module id = 1470
// module chunks = 8